module.exports = __webpack_public_path__ + "img/personal_centerhead_portrait.bee829b5.png";